exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-modify[data-v-3713b293]{background-color:#000;font-family:Web-Geogrotesque;padding:18px!important;height:70px;display:flex;justify-content:space-between}.logo[data-v-3713b293]{height:60px}.nav-link[data-v-3713b293]{color:#fff!important;font-family:Raleway,sans-serif;font-size:15px}.language>a[data-v-3713b293]{color:#6b3fe6!important}@media (max-width:991.98px){.navbar-nav[data-v-3713b293]{background-color:#000;padding:20px}.navbar-modify[data-v-3713b293]{height:150px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3713b293","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NavBar.vue
// module id = 311
// module chunks = 9